import { velocityConfig } from '@/app/config'
import { SmallActionButtonColors } from '@/app/types'
import { player } from '.'
import { gamePhaseState } from '@/stores'

/**
 * Downhill stav manager
 */
export class DownhillManager {

  /** Realne citanie frameow ked klesa lyziar */
  private framesWhenPlayerIsLower = 0

  /** Samotne povolenie ci sa smie spustat wonhill */
  private isDownhillAllowed = false

  /** Predosla pozicia na osi Y potrebna na vykonanie rozhodnutia o aktualnej pozicii */
  private previousPositionY = 0

  /**
   * Obraz stateu storageu ktorym zabezpecime, ze nebudeme permanentne posielat zmenu stavou
   * do storage.
   */
  private localStateImage = true

  /**
   * Obraz stateu storageu ktorym zabezpecime, ze nebudeme permanentne posielat zmenu stavou
   * do storage - farba obrazka
   */
  private actualColor = SmallActionButtonColors.yellow

  /** manualne povolenie downhillu */
  public allowDownhill(): void {

    this.isDownhillAllowed = true

  }

  /**
   * Public metoday na zistenie ci je downhill
   * @returns Ci je downhill povoleny
   */
  public getDownhillAllowed(): boolean {

    return this.isDownhillAllowed

  }

  /**
   * Zistenie ci sa ma udiat akcia zmeny povolenia downhillu
   */
  private checkIfActionMustHappen(): void {

    this.isDownhillAllowed = player.getVelocityGradient() < velocityConfig.downhillGradientLimit

  }

  /**
   * Zistime ci je hrac nizsie ako bol v predoslom frame
   */
  private checkIfPlayerIsLower(): void {

    if (this.previousPositionY > player.playerObject.position.y) {

      this.framesWhenPlayerIsLower++

    } else {

      this.framesWhenPlayerIsLower = 0

    }

  }

  /**
   * Prehodime aktualnu poziciu ako minulu poziciu.
   */
  private reassignPreviousPosition(): void {

    this.previousPositionY = player.playerObject.position.y

  }

  /**
   * Postupnost logiky rozhodnutia. NEMENIT PORADIE METOD
   */
  private allowDownhillLogic(): void {

    this.checkIfPlayerIsLower()
    this.reassignPreviousPosition()
    this.checkIfActionMustHappen()

  }

  /**
   * Metoda na ovladanie UI stavou
   */
  private makeOperationsInUiState(): void {

    this.decideButtonColor()

    if (this.isDownhillAllowed) {

      if (!this.localStateImage) {

        // nechat downhill button povoleny
        gamePhaseState().isAllowedToTuck = true
        this.localStateImage = true

      }

    } else {

      if (player.isCrouching) {

        if (!this.localStateImage) {

          // nechat downhill button povoleny
          gamePhaseState().isAllowedToTuck = true
          this.localStateImage = true

        }

      } else {

        if (this.localStateImage) {

          // zrusime povolenie ist do downhillu
          gamePhaseState().isAllowedToTuck = false
          this.localStateImage = false

        }

      }

    }

  }

  /**
   * Nastavenie farby pre button
   * @param color - Farba
   */
  private setButtonColor(color: SmallActionButtonColors): void {

    if (this.actualColor === color) return

    this.actualColor = color

    // zmenime farbu
    gamePhaseState().downhillButtonColor = color

  }

  /**
   * nastavime farbu obrazka
   */
  private decideButtonColor(): void {

    let color = SmallActionButtonColors.yellow
    if (player.isCrouching) color = SmallActionButtonColors.green

    this.setButtonColor(color)

  }

  /**
   * Update metoda ktoru mame pouzit externe
   */
  public update(): void {

    this.allowDownhillLogic()
    this.makeOperationsInUiState()

  }

}
